import React from 'react';
import TileLibraryTrendIcon from './TileLibraryTrendIcon';

export const TILE_LIBRARY_TREND_FILLS = {
  green: '#1B963B',
  blue: '#2563EB',
  orange: '#EA580C',
  amber: '#D97706',
};

/** @param {string} [fill] */
export function createTileLibraryTrendIcon(fill = TILE_LIBRARY_TREND_FILLS.green) {
  return <TileLibraryTrendIcon fill={fill} aria-hidden />;
}

export const tileLibrarySvgGreen = createTileLibraryTrendIcon(TILE_LIBRARY_TREND_FILLS.green);
export const tileLibrarySvgBlue = createTileLibraryTrendIcon(TILE_LIBRARY_TREND_FILLS.blue);
export const tileLibrarySvgOrange = createTileLibraryTrendIcon(TILE_LIBRARY_TREND_FILLS.orange);
export const tileLibrarySvgAmber = createTileLibraryTrendIcon(TILE_LIBRARY_TREND_FILLS.amber);

export const TILE_LIBRARY_ICONS = {
  'trend-green': tileLibrarySvgGreen,
  'trend-blue': tileLibrarySvgBlue,
  'trend-orange': tileLibrarySvgOrange,
  'trend-amber': tileLibrarySvgAmber,
};

/** @param {string} [iconKey] @param {import('react').ReactNode} [svgIcon] */
export function resolveTileLibraryIcon(iconKey, svgIcon) {
  if (svgIcon) return svgIcon;
  if (iconKey && TILE_LIBRARY_ICONS[iconKey]) return TILE_LIBRARY_ICONS[iconKey];
  return null;
}
